var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hinava_random_uuid_64135337584954994129104224465515056121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7296 16.373C19.9051 15.8354 20 15.2613 20 14.665C20 11.6274 17.5376 9.165 14.5 9.165C11.4624 9.165 9 11.6274 9 14.665C9 15.2978 9.10685 15.9055 9.3035 16.4713C8.34164 16.4632 7.47773 16.4549 6.80621 16.4484C6.07374 16.4414 5.57017 16.4365 5.41805 16.4365C4.5814 16.4365 2.36857 15.3077 2.48977 12.2533C3.03836 9.81219 4.68599 8.59295 6.67304 9.11586C6.67304 7.2334 8.32896 5.53812 10.438 5.03718C12.8195 4.47152 14.935 5.03718 15.7716 7.44255C19.4319 7.12881 19.4319 9.11586 19.4319 10.6846C22.8921 12.1263 21.3491 15.8276 19.7296 16.373Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 18.165C16.433 18.165 18 16.598 18 14.665C18 12.732 16.433 11.165 14.5 11.165C12.567 11.165 11 12.732 11 14.665C11 16.598 12.567 18.165 14.5 18.165ZM14.5 19.165C16.9853 19.165 19 17.1503 19 14.665C19 12.1797 16.9853 10.165 14.5 10.165C12.0147 10.165 10 12.1797 10 14.665C10 17.1503 12.0147 19.165 14.5 19.165Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4148 12.5848C12.6344 12.3651 12.9906 12.3651 13.2102 12.5848L14.5 13.8745L15.7898 12.5848C16.0094 12.3651 16.3656 12.3651 16.5852 12.5848C16.8049 12.8044 16.8049 13.1606 16.5852 13.3802L15.2955 14.67L16.5852 15.9598C16.8049 16.1794 16.8049 16.5356 16.5852 16.7552C16.3656 16.9749 16.0094 16.9749 15.7898 16.7552L14.5 15.4655L13.2102 16.7552C12.9906 16.9749 12.6344 16.9749 12.4148 16.7552C12.1951 16.5356 12.1951 16.1794 12.4148 15.9598L13.7045 14.67L12.4148 13.3802C12.1951 13.1606 12.1951 12.8044 12.4148 12.5848Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hinava_random_uuid_64135337584954994129104224465515056121",
    x: 2.48499,
    y: 4.835,
    width: 19.0282,
    height: 14.33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4080_8377"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.b5a9b2722fd7317b08bdbc31c21fbbcc.svg";
export { ForwardRef as ReactComponent };